"use strict";

exports.__esModule = true;
exports.default = void 0;
var _root = _interopRequireDefault(require("./_root.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** Built-in value references. */
var Uint8Array = _root.default.Uint8Array;
var _default = exports.default = Uint8Array;